import React from "react";
import PropTypes from "prop-types";

import dateFuncs from "./dateFuncs";

const RoDateField = ({ value, labelText }) => (
  <div className="field">
    <label htmlFor={labelText}>{labelText}</label>
    <div>{value ? dateFuncs.displayDateYY(value) : "-"}</div>
  </div>
);

RoDateField.propTypes = {
  value: PropTypes.string,
  labelText: PropTypes.string.isRequired
};

export default RoDateField;
